import React from "react";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { twMerge } from 'tailwind-merge';

const BackButton = ({ link, className }: { link?: string, className?: string }) => {
  const navigate = useNavigate();

  const goBack = () => {
    link ? navigate(link) : navigate(-1);
  };

  return (
    <div className="mb-4">
      <AiOutlineArrowLeft
        onClick={goBack}
        className={twMerge("text-primary cursor-pointer text-2xl md:text-3xl", className)}
      />
    </div>
  );
};

export default BackButton;